// extracted by mini-css-extract-plugin
export var bisolnatur = "styles-module--bisolnatur--ZBwD8";
export var breadcrumb = "styles-module--breadcrumb--eluh6";
export var content = "styles-module--content--3DbNV";
export var filter = "styles-module--filter--1-B1i";
export var header = "styles-module--header--1N4se";
export var holder = "styles-module--holder--mwMzm";
export var image = "styles-module--image--kL8j7";
export var productHolder = "styles-module--productHolder--+eMU+";
export var whatHolder = "styles-module--whatHolder--eTk8K";